module.exports = __webpack_public_path__ + "media/img/frontend_application/paper-icon-3ab8da3b769538094727cc7c7576ce45.svg";